import React from 'react';

const activityItems = summary => [
    {
        key: 'rehearsals',
        icon: '📅',
        label: 'Assajos assistits',
        detail: 'Total',
        value: summary.rehearsalCount ?? 0,
        highlighted: summary.rehearsalCount > 0,
    },
    {
        key: 'positions',
        icon: '🎯',
        label: 'Posicions assignades',
        detail: 'Total',
        value: summary.positionCount ?? 0,
        highlighted: summary.positionCount > 0,
    },
    {
        key: 'upcoming-events',
        icon: '🗓️',
        label: 'Esdeveniments futurs',
        detail: 'Amb assistència confirmada',
        value: summary.upcomingEventCount ?? 0,
        highlighted: summary.upcomingEventCount > 0,
    },
    {
        key: 'notifications',
        icon: '🔔',
        label: 'Notificacions',
        detail: 'Estat actual',
        value: summary.hasNotifications ? 'Actives' : 'Inactives',
        highlighted: summary.hasNotifications,
        compact: true,
    },
];

function ActivityItem({ icon, label, detail, value, highlighted, compact }) {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '14px 16px',
            background: 'white',
            borderRadius: '10px',
            border: highlighted ? '2px solid #f56565' : '1px solid #e2e8f0',
            transition: 'all 0.2s ease'
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ fontSize: '18px' }}>{icon}</span>
                <div>
                    <div style={{
                        fontSize: '14px',
                        color: '#2d3748',
                        fontWeight: '500'
                    }}>
                        {label}
                    </div>
                    <div style={{ fontSize: '12px', color: '#a0aec0' }}>
                        {detail}
                    </div>
                </div>
            </div>
            <strong style={{
                fontSize: compact ? '15px' : '20px',
                fontWeight: compact ? '600' : '700',
                color: highlighted ? '#e53e3e' : '#a0aec0',
                minWidth: compact ? undefined : '32px',
                textAlign: 'right'
            }}>
                {value}
            </strong>
        </div>
    );
}

function ReferencedDeletionWarning({ confirmed, onConfirmedChange }) {
    return (
        <div>
            <div style={{
                background: '#fff5f5',
                border: '2px solid #fc8181',
                borderRadius: '12px',
                padding: '16px',
                marginTop: '20px',
                fontSize: '14px',
                color: '#c53030',
                lineHeight: '1.5'
            }}>
                <div style={{
                    fontWeight: '700',
                    marginBottom: '6px',
                    fontSize: '15px'
                }}>
                    ⚠️ ATENCIÓ
                </div>
                Aquest usuari té activitat o posicions vinculades. Eliminar-lo pot fer que
                deixi d'aparèixer en pinyes i esdeveniments fins que es restauri.
            </div>
            <label style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px',
                marginTop: '12px',
                padding: '12px',
                borderRadius: '10px',
                background: '#fffaf0',
                color: '#7b341e',
                fontSize: '14px',
                cursor: 'pointer'
            }}>
                <input
                    type="checkbox"
                    checked={confirmed}
                    onChange={event => onConfirmedChange(event.target.checked)}
                />
                Entenc que aquest casteller té referències i el vull enviar igualment a la paperera.
            </label>
        </div>
    );
}

function DeletionActivitySummary({
    summary,
    requiresConfirmation,
    confirmed,
    onConfirmedChange,
}) {
    return (
        <div style={{ marginBottom: '20px' }}>
            <h4 style={{
                fontSize: '13px',
                fontWeight: '600',
                marginBottom: '12px',
                color: '#718096',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
            }}>
                Activitat
            </h4>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {activityItems(summary).map(item => (
                    <ActivityItem key={item.key} {...item} />
                ))}
            </div>

            {requiresConfirmation ? (
                <ReferencedDeletionWarning
                    confirmed={confirmed}
                    onConfirmedChange={onConfirmedChange}
                />
            ) : null}
        </div>
    );
}

export { activityItems };
export default DeletionActivitySummary;
